import dayjs from 'dayjs'
import { ReplacementDetailProps } from '../../StockMovementsTypes'
import {
  DetailBody, DetailHeader, DetailRow, DetailWrapper,
} from './ReplacementDetail.styles'

export const ReplacementDetail: React.FC<ReplacementDetailProps> = ({
  description, expirationDate, quantity, movementedQuantity,
}) => (
  <DetailWrapper data-testid='replacement-detail'>
    <DetailHeader>{description}</DetailHeader>
    <DetailBody square>
      <DetailRow>
        <div>Validade: {dayjs.utc(expirationDate).format('DD/MM/YYYY')}</div>
        <div>Quantidade: {quantity}</div>
      </DetailRow>
      {movementedQuantity && (
        <DetailRow data-testid='movemented-quantity'>
          <div>Quantidade a ser movimentada: {movementedQuantity}</div>
        </DetailRow>
      )}
    </DetailBody>
  </DetailWrapper>
)
